module.exports = __webpack_public_path__ + "img/HeritageHubSpeciesViewer20220805_2.b293ece7.jpg";